const ChevronLeft: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={props.className ?? ''}>
      <path
        fill="currentColor"
        d="M13 5.92969L6.92969 12L13 18.0703L14.5 16.5703L9.92969 12L14.5 7.42969L13 5.92969Z"
      />
    </svg>
  );
};

export default ChevronLeft;
